<template>
  <div class="task-page">
    <tasks-list :company="companyId"></tasks-list>
  </div>
</template>

<script>
  import TasksList from '../tasks/TasksList'
  import {mapActions, mapGetters} from 'vuex'

  export default {
    name: 'tasks',
    data () {
      return {
        companyId: null
      }
    },
    computed: {
      ...mapGetters([])
    },
    methods: {
      ...mapActions([])
    },
    components: {
      TasksList
    },
    created () {
      document.title = 'Tasks | Clear Assured'
      if (window.ga) {
        window.ga('set', 'contentGroup1', 'DASHBOARD_AREA')
        window.ga('send', 'pageview', {
          'page': location.pathname,
          'location': location.href,
          'title': document.title
        })
      }
      this.companyId = parseInt(this.$route.params.companyId)
    },
    watch: {
      '$route' (to, from) {
        if (to.params.companyId !== from.params.companyId) {
          this.companyId = parseInt(to.params.companyId)
        }
      }
    }
  }
</script>

<style src="@/assets/scss/components/task-root.scss" lang="scss" />



// WEBPACK FOOTER //
// Tasks.vue?1cd79270